import React, { Fragment, useEffect } from 'react'
import { history } from '../../routers/AppRouter'
import { useDispatch } from 'react-redux'
import { scroller, Element } from 'react-scroll'
import { checkZipCode } from '../../redux/actions/auth'
import { toast } from 'react-toastify'

const LandingPage = (props) => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(checkZipCode(false))
  }, [])

  return (
    <Fragment>
      <div className='landing-page container-fluid px-0'>
        <div className='banner bg-danger text-white text-center d-flex align-items-center justify-content-center px-3'>
          <div className='banner-text my-2'>
            <p className='mb-0'>As directed by Governor Reeves, the RAMP Program is no longer accepting applications.</p>
            <p className='mb-0'><span className='f-bold'>PLEASE READ...</span> The RAMP program is closed to new recertifications and applications.  Existing applications and recertifications already in the system will continue to be processed by the date on which they were completed and are subject to funds being available.</p>
          </div>
        </div>
        {/* HERO IMAGE */}
        <div className='hero-img' style={{ minHeight: '450px' }}>
          <div className='row align-items-center' style={{ minHeight: '450px' }}>
            <div className='col-12 px-0 px-md-5'>
              <div className='hero-content col-12 col-lg-6 col-xl-5 mx-0 ml-lg-5 align-items-center'>
                <div className='px-5 px-lg-0'>
                  <h1>Need Assistance? We are here to help!</h1>
                  <p>If you are a Mississippi renter who has not been able to make rent payments due to COVID-19, you may qualify for the Rental Assistance for Mississippians Program (RAMP). RAMP can provide up to 15 months of rental and utility assistance to eligible renters. The funds will be paid directly to the landlord and service providers on behalf of tenants. See if you are eligible.</p>
                  <div className='text-center text-md-left'>
                    <button className='btn btn-primary' onClick={() => {
                      // Requested by Eric 3/24
                      scroller.scrollTo('overview', {
                        duration: 400,
                        delay: 0,
                        smooth: 'easeInOutQuart',
                        offset: -70
                      })
                    }}>Learn More</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* GO TO PRESCREENING */}
        <div className='row text-center align-items-center justify-content-center py-4 py-lg-5'>
          <div className='col-12 col-md-10 col-lg-6 col-xl-5 my-3 mb-3 mb-lg-5 px-5 px-lg-0'>
            <div className='py-2 py-lg-4 px-3 px-lg-0'>
              <h2 className='mb-4'>Apply for Assistance</h2>
            </div>
            <div className='px-3 py-4 py-lg-2'>
              <button className='btn btn-primary btn-sm-block mx-2 mb-3' onClick={() => history.push('/signup/landlord')}>I’m a Landlord</button>
              <button className='btn btn-primary btn-sm-block mx-2 mb-3' onClick={() => {
                if (environment === 'production') {
                  toast.error('The RAMP program has suspended accepting applications at this time')
                } else {
                  history.push('/signup/tenant')
                }
              }}>I’m a Tenant</button>
            </div>
            <div className='px-3'>
              Already applied? <span className='text-primary pointer' onClick={() => history.push('/login')}>Check the status of your application.</span>
            </div>
          </div>
        </div>
        {/* OVERVIEW */}
        <Element name='overview' className='row text-center align-items-center justify-content-center py-4 py-lg-5 bg-light'>
          <div className='col-12 col-md-10 col-xl-9 my-1 px-5 px-lg-0'>
            <div className='px-3 px-lg-0 text-left'>
              <p className='mb-4 f-bold text-primary' style={{ fontSize: '20px' }}>Program Overview</p>
              <p>The RAMP-ERA Program was established by the Consolidated Appropriations Act, 2021 (Pub. L. No. 116-260).  Funding provided by the RAMP-ERA Program will assist eligible households that experience difficulty making timely payments of rent and utilities due to the COVID-19 pandemic.  Mississippi Home Corporation (“MHC”) is administering the program for the State of Mississippi, which received $186,696,633.80 (the “Program”). </p>
              <p>Program funds may be used to provide assistance to a renter household that has a household income at or below 80 percent of the area median and in which at least one or more individuals living in the household: qualifies for unemployment or has experienced a reduction in household income, incurred significant costs, or experienced a financial hardship due to COVID-19; and can demonstrate a risk of experiencing homelessness or housing instability.   </p>
              <p>Eligible households that include an individual who has been unemployed for the ninety (90) days prior to application for assistance and households with income at or below fifty percent of the area median will be prioritized for assistance.  Eligible households may receive up to twelve (12) months of assistance, plus an additional three months if MHC determines the additional months are necessary to ensure housing stability (subject to fund availability).   </p>
            </div>
          </div>
        </Element>
        {/* REQUIREMENTS */}
        <div className='row text-center align-items-center justify-content-center py-4 py-lg-5'>
          <div className='col-12 col-md-10 col-xl-9 my-1 my-lg-3 px-5 px-lg-0 d-flex flex-column flex-md-row'>
            <div className='col-12 px-0'>
              {/* Tenant Requirements */}
              <div className='col-12 px-3 px-lg-0 text-left mb-5'>
                <p className='mb-4 f-bold' style={{ fontSize: '20px' }}>Tenant Requirements</p>
                <div className='pr-0 pr-lg-3'>
                  <div className='d-flex'>
                    <span className='text-success fas fa-check mr-2 mt-1' />
                    <p>Completed Program application</p>
                  </div>
                  <div className='d-flex'>
                    <span className='text-success fas fa-check mr-2 mt-1' />
                    <p>Valid, current identification</p>
                  </div>
                  <div className='d-flex'>
                    <span className='text-success fas fa-check mr-2 mt-1' />
                    <p>Duly-executed, current lease or alternative documentation for proof of residence and rent amount</p>
                  </div>
                  <div className='d-flex'>
                    <span className='text-success fas fa-check mr-2 mt-1' />
                    <p>Documentation supporting household income</p>
                  </div>
                  <div className='d-flex'>
                    <span className='text-success fas fa-check mr-2 mt-1' />
                    <p>Proof one or more individuals within the household can demonstrate a risk of experiencing homelessness or housing instability</p>
                  </div>
                  <div className='d-flex'>
                    <span className='text-success fas fa-check mr-2 mt-1' />
                    <p>Proof one or more individuals within the household has qualified for unemployment benefits OR has experienced a reduction in household income, incurred significant costs, or experienced other financial hardship due to COVID-19</p>
                  </div>
                  <div className='d-flex'>
                    <span className='text-success fas fa-check mr-2 mt-1' />
                    <p>Landlord Participation Form (with landlord's W9 Form and ACH Credit Authorization if the landlord agrees to participate and has not completed online application)</p>
                  </div>
                  <div className='d-flex'>
                    <span className='text-success fas fa-check mr-2 mt-1' />
                    <p>If requesting utility assistance, a copy of tenant's bill, showing the name of the service provider, account number and name and address of customer.</p>
                  </div>
                </div>
                <a className='btn btn-sm btn-primary mt-3' rel='noopener noreferrer'>See All Tenant Documents</a>
              </div>
              {/* Landlord Requirements */}
              <div className='col-12 px-3 px-lg-0 text-left'>
                <p className='mb-4 f-bold' style={{ fontSize: '20px' }}>Landlord Requirements</p>
                <div className='pr-0 pr-lg-3'>
                  <div className='d-flex'>
                    <span className='text-success fas fa-check mr-2 mt-1' />
                    <p>IRS W-9 Form</p>
                  </div>
                  <div className='d-flex'>
                    <span className='text-success fas fa-check mr-2 mt-1' />
                    <p>ACH Direct Deposit Authorization</p>
                  </div>
                </div>
                <a className='btn btn-sm btn-primary mt-3' rel='noopener noreferrer'>See All Landlord Documents</a>
              </div>
            </div>
          </div>
        </div>

        <div className='row text-center align-items-center justify-content-center pb-4 pb-lg-5'>
          <div className='col-12 col-md-10 col-xl-9 my-1 px-5 px-lg-0'>
            <div className='px-3 px-lg-0 text-left'>
              <p className='mb-4'><span className='f-bold'>Note: </span>Program funds will be paid directly to landlords and utility service providers; however, if a landlord or utility provider does not wish to participate, such funds may be paid directly to the eligible household. </p>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  )
}

LandingPage.propTypes = {

}

export default LandingPage
